import { useScheduleStore } from '@/store/useScheduleStore'
import { useCallback } from 'react'

interface StepStatus {
  completed: boolean
  disabled: boolean
  path: string
}

export const useStepbarSteps = () => {
  const getStepsStatus = useCallback((): StepStatus[] => {
    const { flowType, location, patient, healthPlan, product, slot } =
      useScheduleStore.getState()

    const isHomeCompleted = Boolean(product?.id)
    const isLocationCompleted = Boolean(location?.id)
    const isPatientCompleted =
      Boolean(patient?.birthDate) && Boolean(patient?.gender)
    const isPaymentCompleted = Boolean(healthPlan?.id)
    const isScheduleCompleted = Boolean(slot?.id)

    return [
      { path: '/', completed: isHomeCompleted, disabled: false },
      {
        path: '/local',
        completed: isLocationCompleted,
        disabled: flowType === 'doctor'
      },
      {
        path: '/paciente',
        completed: isPatientCompleted,
        disabled: false
      },
      {
        path: '/pagamento',
        completed: isPaymentCompleted,
        disabled: false
      },
      {
        path: '/agendar-consulta',
        completed: isScheduleCompleted,
        disabled: false
      }
    ]
  }, [])

  const steps = getStepsStatus()

  return {
    getStepsStatus,
    steps
  }
}
